"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var RandomizerRequiredException = (function (_super) {
    __extends(RandomizerRequiredException, _super);
    function RandomizerRequiredException() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.message = "This gremlin requires a randomizer to run. Please call randomizer(randomizerObject) before executing the gremlin";
        return _this;
    }
    RandomizerRequiredException.prototype.toString = function () {
        return this.message;
    };
    return RandomizerRequiredException;
}(Error));
exports.RandomizerRequiredException = RandomizerRequiredException;
